import React from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useFormikContext } from 'formik';
import AlertCircleOutline from 'mdi-react/AlertCircleOutlineIcon';

import { RolesMode } from 'entities/Roles';
import { tripStatuses, TripStatusIds } from '../../../entities/Trip';
import { Textarea } from '../Forms';

type Props = {
  handleChange: (e: React.ChangeEvent<any>) => void;
  mode: RolesMode;
  statusId: TripStatusIds;
  errors?: any;
};

const DepartureComment: React.FC<Props> = ({ handleChange, mode, statusId, errors }) => {
  const formik = useFormikContext();
  const {
    // @ts-ignore
    entrySecurityMessage,
    // @ts-ignore
    orderAdjustment,
    // @ts-ignore
    toleranceMessage,
    // @ts-ignore
    departureSecurityMessage,
    // @ts-ignore
    orders,
  } = formik.values;
  const restStatus =
    ((statusId === tripStatuses.parkingInLine || statusId === tripStatuses.waitingOrder) && mode === 'security') ||
    statusId === tripStatuses.waiting ||
    statusId === tripStatuses.downloading ||
    statusId === tripStatuses.parking ||
    statusId === tripStatuses.onPause;

  const isNotLoaded = restStatus && orders && !orders.length;
  const isDirector = mode === 'director';

  return (
    <Card className="mb-3">
      <Card.Header className="d-flex py-0">
        {errors && errors.toleranceMessage && (
          <span className="d-flex align-items-center justify-content-center">
            <AlertCircleOutline size={15} className="text-danger" />
            &nbsp;
          </span>
        )}
        <span className="d-block font-weight-bolder mr-5 py-1">Коментарі рейсу</span>
      </Card.Header>
      <Card.Body>
        {(isDirector || toleranceMessage) && (
          <Row className="w-100">
            <Col>
              <span>Причина перевищення толерансу (завсклад)</span>
              <br />
              <Textarea
                name="toleranceMessage"
                onChange={handleChange}
                onLine
                maxLength={150}
                disabled={!isDirector || statusId !== tripStatuses.waitingAdmin}
              />
            </Col>
          </Row>
        )}
        {((statusId === 1 && mode === 'security') || entrySecurityMessage) && (
          <Row className="w-100">
            <Col>
              <span>В&apos;їзд (охорона)</span>
              <br />
              <Textarea
                name="entrySecurityMessage"
                onChange={handleChange}
                maxLength={150}
                onLine
                disabled={statusId > 1}
              />
            </Col>
          </Row>
        )}
        {(mode === 'ordering' || orderAdjustment) && (
          <Row className="w-100">
            <Col>
              <span>Оформлення документів (виписка)</span>
              <br />
              <Textarea
                name="orderAdjustment"
                onChange={handleChange}
                maxLength={150}
                onLine
                disabled={mode !== 'ordering'}
              />
            </Col>
          </Row>
        )}
        {((!isNotLoaded && statusId > tripStatuses.downloading) ||
          (!isNotLoaded &&
            statusId > tripStatuses.downloading &&
            !departureSecurityMessage &&
            mode !== 'security')) && (
          <Row className="w-100">
            <Col>
              <span>Виїзд (охорона)</span>
              <br />
              <Textarea
                name="departureSecurityMessage"
                onChange={handleChange}
                maxLength={150}
                onLine
                disabled={mode !== 'security'}
              />
            </Col>
          </Row>
        )}
        {isNotLoaded && (
          <Row className="w-100">
            <Col>
              <span>Bиїзд без завантаження (охорона)</span>
              <br />
              <Textarea
                name="notLoadedMessage"
                onChange={handleChange}
                onLine
                maxLength={150}
                disabled={mode !== 'security'}
              />
            </Col>
          </Row>
        )}
      </Card.Body>
    </Card>
  );
};

export default DepartureComment;
